<div *ngIf="docItems else docitemloading">

  <p-table #docItemTable id="docItemTable"
           [value]="docItems"
           dataKey="PRODCODE"
           [loading]="loading"
           selectionMode="single"
           [(selection)]="sDI"
           [rowHover]="true"
           [resizableColumns]="true"
           styleClass="p-datatable-gridlines p-datatable-striped p-datatable-customers">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="PRODCODE" style="width:35%" pResizableColumn>Код товара <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMPRODNAME" style="width:55%" pResizableColumn>Название товара <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMQTY" style="width:7rem" pResizableColumn *ngIf="showQuantity">Количество <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>

        <th pSortableColumn="DOCITEMPRICE" style="width:8rem" pResizableColumn *ngIf="showPrice">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMSUM" style="width:8rem" pResizableColumn *ngIf="showPrice">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>

        <th pSortableColumn="U4ETKA" style="width:8rem" pResizableColumn *ngIf="canSeeU4etka">{{diU4ETKAColumnName}} <p-sortIcon field="U4ETKA"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMSUMU4" style="width:8rem" pResizableColumn *ngIf="canSeeU4etka">Сумма {{diU4ETKAColumnName}} <p-sortIcon field="DOCITEMSUMU4"></p-sortIcon></th>

        <th pSortableColumn="DOCITEMTEXT1" style="width:15%" pResizableColumn *ngIf="diText1Column">{{diText1ColumnName}}<p-sortIcon field="DOCITEMTEXT1"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMTEXT2" style="width:15%" pResizableColumn *ngIf="diText2Column">{{diText2ColumnName}}<p-sortIcon field="DOCITEMTEXT2"></p-sortIcon></th>

        <th pSortableColumn="PAYITEMCLIID" style="width:15%" pResizableColumn *ngIf="diOrderColumn">{{diOrderColumnName}}<p-sortIcon field="PAYITEMCLIID"></p-sortIcon></th>

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-docItem>
      <tr [pSelectableRow]="docItem">

        <td style="overflow: visible !important; ">
          <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
            <a [routerLink]="['/edit-product', docItem.PRODID]">{{docItem.PRODCODE}}</a>
          </div>
        </td>

        <td style="">{{docItem.DOCITEMPRODNAME}}</td>

        <td style="text-align: right" *ngIf="showQuantity">{{docItem.DOCITEMQTY | number:'1.0-2'}}</td>

        <td style="text-align: right" *ngIf="showPrice">{{docItem.DOCITEMPRICE | number:'1.2-2'}}</td>
        <td style="text-align: right" *ngIf="showPrice">{{docItem.DOCITEMSUM | number:'1.2-2' }}</td>

        <td style="text-align: right" *ngIf="canSeeU4etka">{{docItem.U4ETKA | number:'1.2-2'}}</td>
        <td style="text-align: right" *ngIf="canSeeU4etka">{{docItem.DOCITEMSUMU4 | number:'1.2-2' }}</td>

        <td style="" *ngIf="diText1Column">{{docItem.DOCITEMTEXT1}}</td>
        <td style="" *ngIf="diText2Column">{{docItem.DOCITEMTEXT2}}</td>

        <td style="" *ngIf="diOrderColumn">{{docItem.PAYITEMCLIID}}</td>

      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr *ngIf="canSeeU4etka">
        <td colspan="7">Пустой документ</td>
      </tr>

      <tr *ngIf="!canSeeU4etka">
        <td colspan="5">Пустой документ</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #docitemloading>
  <p>Содержимое документа загружается...</p>
</ng-template>
